
'use client'

import { useState, useRef, useEffect } from "react";
import { Upload, message } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import { createClientService } from "@/lib/http/client";

export default function SearchUpload(props) {

    const [fileList, setFileList] = useState([]);

    const [uploading, setUploading] = useState(false); // 新增上传状态跟踪

    const OSSDataRef = useRef();


    // 新增：消息实例引用
    const messageRef = useRef(null);

    // 新增：清理消息的副作用
    useEffect(() => {
        return () => {
            if (messageRef.current) {
                message.destroy(messageRef.current);
            }
        };
    }, []);


    const getExtraData = (file) => {
        const current = OSSDataRef.current;
        return {
            key: file.key,
            OSSAccessKeyId: current?.accessid,
            policy: current?.policy,
            Signature: current?.signature
        };
    };

    const init = () => {

        return new Promise((resolve, reject) => {
            try {
                createClientService().get(
                    'mtop.oss.getH5PolicySign',
                    { data: { dir: 'bdtmp/data/', bucket: 'public-read-bkt-oss' } },
                    { cache: false }
                ).then(res => {
                    OSSDataRef.current = res;
                    resolve();
                })
            } catch (error) {
                console.log("🚀 ~ init ~ error:", error)
            }
        });




    }

    const beforeUpload = async (file) => {

        setUploading(true);
        messageRef.current = message.info({
            content: 'Picture upload in progress ...',
            duration: 0, // 持续显示直到手动关闭
            key: 'upload-status'
        });

        await init();

        // 生成文件名
        const suffix = file.name.slice(file.name.lastIndexOf('.'));
        const uniqueId = Math.random().toString(36).slice(2, 10); // 8位随机字符串
        const filename = `${Date.now()}_${uniqueId}${suffix}`; // 添加随机标识符
        file.key = OSSDataRef.current.dir + filename;
        file.url = `https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com/${OSSDataRef.current.dir}${filename}`;

        return file;
    }

    const handleChange = ({ file, fileList }) => {

        if (file.status === 'error') {
            setUploading(false);
            message.destroy('upload-status'); // 清除上传中消息
            message.error('Upload failed');
        }

        if (file.status === 'done') {
            setUploading(false);
            message.destroy('upload-status'); // 清除上传中消息
            message.success('Upload successful');
            props?.handleUploadDone?.(file.url);
        }
    }

    const uploadProps = {
        name: 'file',
        maxCount: 1,
        action: `https://public-read-bkt-oss.oss-cn-hangzhou.aliyuncs.com`,
        multiple: false,
        data: getExtraData,
        beforeUpload,
        onChange: handleChange,
        itemRender: () => null,
        disabled: uploading
    }


    return <Upload  {...uploadProps}>
        <CameraOutlined className="search_icon icon_flex" />
    </Upload>
}